import { Styles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core';
import theme, { colors } from 'theme';

export const STATE_MENU_STYLES: Styles<Theme, {}> = {
  mainMenu: {
    width: '80px',
    height: '100%',
    background: 'linear-gradient(230deg, #2B3648 14.51%, #4A515B 85.49%);',
    padding: '1rem 0',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all .3s ease',
  },
  menu: {
    position: 'fixed',
    display: 'flex',
    top: 0,
    left: 0,
    width: 'auto',
    height: '100%',
    background: 'linear-gradient(230deg, #2B3648 14.51%, #4A515B 85.49%);',
    zIndex: theme.zIndex.drawer + 10,

    '&$isOpen': {
      '& $mainMenu': {
        width: '270px',
      },
      '& $openCloseIcon': {
        transform: 'rotate(0deg)',
      },
      '& $listItem > $navLink': {
        maxWidth: '100%',
      },
      '& $listItem $navLinkText': {
        opacity: '1',
        pointerEvents: 'auto',
        transitionDelay: '.3s',
      },
      '& $listItem': {
        padding: '0 0.5rem',
      },
      '& $logoEnd': {
        opacity: '1',
        pointerEvents: 'auto',
        transitionDelay: '.1s',
      },
      '& $category': {
        margin: '9px 1rem 0',
      },
    },
  },
  isOpen: {},
  listItem: {
    margin: '15px 0',
    padding: '0 1rem',
    transition: 'all .3s ease .1s',
    '&:last-child': {
      marginBottom: '1.5rem',
    },
  },
  blockDisplay: {
    display: 'block',
  },
  navLinkText: {
    opacity: '0',
    pointerEvents: 'none',
    transition: 'all .3s ease 0s',
    whiteSpace: 'nowrap',
  },
  submenuLink: {
    cursor: 'pointer',
    color: colors.white,
    fontWeight: 400,
    fontSize: '14px',
    width: '100%',
    borderRadius: '4px',
    padding: '0.5rem 1rem 0.5rem 0.5rem',
    transition: 'all .3s ease 0s',
    textDecoration: 'none',
    whiteSpace: 'nowrap',

    '&:hover': {
      background: 'rgba(75, 91, 115, 0.9)',
    },
  },
  navLink: {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    color: colors.white,
    fontWeight: 400,
    fontSize: '14px',
    width: '100%',
    maxWidth: '32px',
    borderRadius: '4px',
    padding: '0.5rem 1rem 0.5rem 0.5rem',
    transition: 'all .3s ease 0s',
    textDecoration: 'none',
    whiteSpace: 'nowrap',

    '& span': {
      whiteSpace: 'nowrap',
    },

    '&:hover': {
      background: 'rgba(75, 91, 115, 0.9)',
    },
  },
  submenuTitleIcon: {
    '& > $icon': {
      width: '1.5rem',
      marginRight: '0.5rem',
    },
  },
  icon: {
    width: '1rem',
    marginRight: '0.8rem',
    flexShrink: 0,
    '& > path': {
      fill: colors.white,
    },
  },
  activeLink: {
    background: 'rgba(75, 91, 115, 0.9)',
  },
  logo: {
    display: 'inline-flex',
    width: 'fit-content',
    padding: '0 1.5rem',
    marginBottom: '1rem',
  },
  logoEnd: {
    opacity: '0',
    pointerEvents: 'none',
    transition: 'all .3s ease',
    marginLeft: '5px',
  },
  category: {
    padding: 0,
    borderBottom: `1px dashed ${colors.gray700}`,
    margin: '9px 0.5rem 0',
    transition: 'all .3s ease .1s',
    '&:last-child': {
      borderBottom: `none`,
    },
  },
  submenu: {
    height: '100%',
    background: '#252D39',
    boxShadow: '1px 0px 4px rgba(43, 55, 73, 0.25)',
    padding: '2rem 0',
    zIndex: -1,
    maxWidth: 0,
    overflow: 'hidden',
    transition: 'all .3s ease',
  },
  submenuIsOpen: {
    maxWidth: '300px',
  },
  openCloseIcon: {
    position: 'absolute',
    top: '1rem',
    right: '-15px',
    transition: 'all .3s ease',
    transform: 'rotate(180deg)',
    zIndex: theme.zIndex.drawer + 1,
    cursor: 'pointer',
  },
  openCloseIconisOpen: {
    transform: 'rotate(0deg)',
  },
  submenuTitle: {
    display: 'flex',
    fontSize: '1rem',
    padding: '0 2rem 0 1rem',
    paddingBottom: '.5rem',
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      left: '1rem',
      bottom: 0,
      height: '1px',
      width: '2rem',
      background: colors.white,
    },
  },
  submenuTitleText: {
    whiteSpace: 'nowrap',
    color: colors.white,
  },
  hidden: {
    display: 'none',
  },
};
